// API endpoints - Host is configured via environment variables

// Get the API host from environment variables
const HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000';
export const USER_REFRESH = `${HOST}/auth/refresh`;

export const PERIOD_CONFIG = `${HOST}/get_period_configs`;
export const NLP_SEARCH = `${HOST}/api/search`;
export const EXPORT_LOG = `${HOST}/api/export-log`;
export const EXPORT_DATA = `${HOST}/api/export`;
export const RECENT_QUERIES = `${HOST}/api/recent-queries`;
export const USER_LOGIN = `${HOST}/auth/login`;
export const AUTH_REFRESH = `${HOST}/auth/refresh`;
export const COLLEGES_LIST = `${HOST}/auth/colleges`;
export const TEAMS_LIST = `${HOST}/auth/teams`;
export const TEAMS_ALL = `${HOST}/auth/teams/all`;
export const TEAMS_SEARCH = `${HOST}/auth/teams/search`;
export const NAME_SUGGESTION = `${HOST}/api/name-suggestions`;
export const REPORT_ISSUE = `${HOST}/api/report-issue`;
export const PROFILE = `${HOST}/api/profile`;
export const PLAN_DETAILS = `${HOST}/api/plan-details`;
export const SUBSCRIPTION_COST = `${HOST}/api/subscription-cost`;
export const PLAYER_PROFILE = `${HOST}/api/player_profile`;
export const PLAYER_RECORDS = `${HOST}/api/player-records`;
export const PLAYER_SEASON_AND_CAREER_HIGHS = `${HOST}/api/player-highs`;
export const PLAYER_GAME_LOGS = `${HOST}/api/player-game-logs`
export const PLAYER_STREAKS = `${HOST}/api/player-streaks`;
export const PLAYER_STREAKS_MAPPING = `${HOST}/api/player-streaks-mapping`;
export const VISUALIZE = `${HOST}/api/visualize/`;


//Team Dashboard endpoints
export const TEAM_PROFILE = `${HOST}/api/team-profile`;
export const TEAM_RECORDS = `${HOST}/api/team-records`;
export const TEAM_SEASON_HIGHS = `${HOST}/api/team-season-highs`;
export const TEAM_GAME_LOGS = `${HOST}/api/team-game-logs`;
export const TEAM_STREAKS = `${HOST}/api/team-streaks`;
export const TEAM_STREAKS_MAPPING = `${HOST}/api/team-streaks-mapping`;




export const VERIFY = `${HOST}/auth/verify`;
export const INFO = "/info/";

// export const TERMS_AGREEMENT = `${HOST}/auth/terms-agreed`;
export const USER_CREATE =`${HOST}/auth/register`;
export const TERMS_AGREED =`${HOST}/auth/terms_agreed`;
export const GAME_DASHBOARD = `${HOST}/api/game-dashboard`;
export const GAME_PLAYER_STATS = `${HOST}/api/game-player-stats`;
export const GAME_TEAM_STATS = `${HOST}/api/game-team-stats`;
export const GAME_ROSTERS = `${HOST}/api/game-rosters`;
export const GAME_SUMMARY = `${HOST}/api/game-summary`;
// export const GAME_PLAY_BY_PLAY = `${HOST}/api/gameplay`;
export const PASSWORD_RESET_REQUEST = `${HOST}/auth/password-reset-request`;
export const PASSWORD_RESET = `${HOST}/auth/password-reset`;

// Admin endpoints
export const ADMIN_ALL_USERS = `${HOST}/api/admin/users`;
export const ADMIN_GET_SPORTS = `${HOST}/api/admin/getSports`;
export const ADMIN_GET_ALL_TEAMS = `${HOST}/api/admin/getAllTeams`;
export const ADMIN_GET_TEAMS = `${HOST}/api/admin/getTeams`;
export const ADMIN_GET_TEAM_SEAT_INFO = `${HOST}/api/admin/getTeamSeatInfo`;
export const ADMIN_GET_TEAM_DETAILS = `${HOST}/api/admin/getTeamDetails`;
export const ADMIN_ONBOARD_TEAM = `${HOST}/api/admin/onboard-team`;
export const ADMIN_TEAM_REQUESTS = `${HOST}/api/admin/team-requests`;
export const ADMIN_RECORDBOOK_REQUESTS = `${HOST}/api/admin/recordbook-requests`;
export const ADMIN_USER_SEAT_REQUESTS = `${HOST}/api/admin/user-seat-requests`;
export const ADMIN_GET_USER = `${HOST}/api/admin/user`;
export const ADMIN_CREATE_USER = `${HOST}/api/admin/create-user`;
export const ADMIN_TEAM_ADMINS = `${HOST}/api/admin/team-admins`;
export const ADMIN_UPDATE_USER = `${HOST}/api/admin/update-user`;
export const ADMIN_SEARCH_USERS = `${HOST}/api/admin/search-users`;
export const ADMIN_BILLING_PREVIEW = `${HOST}/api/admin/users`;
export const ADMIN_GENERATE_INVOICE = `${HOST}/api/admin/generate-invoice`;
export const ADMIN_INVOICES = `${HOST}/api/admin/invoices`;
export const ADMIN_INVOICE_ANALYTICS = `${ADMIN_INVOICES}/analytics`;
export const ADMIN_CHECKOUTS = `${HOST}/api/admin/checkouts`;
export const ADMIN_SUBSCRIPTION_TRACKER = `${HOST}/api/admin/subscription-tracker`;
export const ADMIN_SUBSCRIPTION_TRACKER_TEAM_SUMMARIES = `${HOST}/api/admin/subscription-tracker/team-summaries`;
export const ADMIN_TEAM_SUBSCRIPTION_TRACKER = `${HOST}/api/admin/team-subscription-tracker`;
export const ADMIN_TEAM_SUBSCRIPTION_DETAILS = `${HOST}/api/admin/teams`;
export const ADMIN_USER_SUBSCRIPTION_DETAILS = `${HOST}/api/admin/users`;
export const ADMIN_CONFERENCE_SUBSCRIPTION_TRACKER = `${HOST}/api/admin/conference-subscription-tracker`;
export const ADMIN_CONFERENCE_SUBSCRIPTION_TEAMS = `${HOST}/api/admin/conferences/subscription-teams`;
export const ADMIN_CACHE_QUERIES = `${HOST}/api/admin/cache-queries`;
export const LOGIN_PAGE_REPORT_ISSUE = `${HOST}/api/login-issue-report`;
export const ANALYTICS = `${HOST}/api/admin/analytics/searches`;
export const TRIAL_END_API = `${HOST}/api/trial_end`;
export const REQUEST_TEAM_API = `${HOST}/api/request-team`;
export const USER_SEAT_REQUESTS_API = `${HOST}/api/user-seat-requests`;
export const UPLOAD_NOTIFICATIONS_API = `${HOST}/api/user-requests/upload-notifications`;

// Route endpoint
export const LOGIN = "/login";
export const SIGNUP = "/signup";
export const DASHBOARD = "/dashboard";
export const SCHEDULE = "/schedule";

export function getSchedulePath(teamName: string, season: number | string): string {
  return `${SCHEDULE}/${encodeURIComponent(teamName)}/${season}`;
}

export const PROFILE_PAGE = "/profile";
export const RESULTSCREEN = "/resultscreen";
export const PLAYERDASHBOARD = "/playerdashboard";
export const TEAMDASHBOARD = "/teamdashboard";
export const GAMEDASHBOARD = "/gamedashboard";
export const REQUEST_TEAM = "/request-team";
export const SUBSCRIPTION = "/subscription";
export const SUBSCRIPTION_API = `${HOST}/subscription-plans`;
export const ADDONS = "/addons";
export const SPORT_ACCESS = "/sport-access";
export const TEAM_SEAT_OVERFLOW = "/team-seat-overflow";
export const CHECKOUT = "/checkout";
export const INVOICE_STATUS = "/invoice-status";
export const TRIAL_EXPIRED = "/trial-expired";

// Billing / Stripe
export const TEAM_SUBSCRIPTION_ID_API = `${HOST}/api/team_subscription_id`;
export const STRIPE_CREATE_SESSION = `${HOST}/api/stripe/create-session`;
export const STRIPE_PAYMENT_STATUS = `${HOST}/api/stripe/payment-status`;
export const STRIPE_GENERATE_INVOICE = `${HOST}/api/generate-invoice`;

// Addons
export const STAT_CREW_ADDON_API = `${HOST}/api/addons/stat-crew`;

// Billing routes
export const PAYMENT_RESULT = "/payment/result";

export const RESETPASSWORD = "/reset-password";
export const VALIDATE_RESET_TOKEN = `${HOST}/auth/password-reset/validate`;
export const REGENERATE_RESET_TOKEN = `${HOST}/auth/regenerate-token`;

export const PAGENOTFOUND = "/404";
export const HOME = "/";
export const VERIFY_ROUTE = "/verify";
export const ADMIN_DASHBOARD = "/admin/dashboard";
export const ADMIN_SUBSCRIPTION = "/admin/subscription";
export const ADMIN_SUBSCRIPTION_TEAM_SUB = "/admin/subscription/team-sub";
export const ADMIN_SUBSCRIPTION_USER_SUB = "/admin/subscription/user-sub";
export const TERMS_OF_SERVICE = "/terms-and-conditions";


// RECORD BOOK
export const RECORD_NOTICE = `${HOST}/api/record-stats`
export const RECORD_NOTICE_PLAYERS = `${HOST}/api/record-notice`
export const RECORD_CATEGORIES = `${HOST}/api/categories`

//TYPE AHEAD
export const TYPE_AHEAD_SUGGESTION = `${HOST}/api/type-ahead`

//Matches
export const UPCOMING_MATCHES = `${HOST}/api/matches`
export const FULL_SCHEDULE = `${HOST}/api/full-schedule`

export const RAG_ASK = `${HOST}/api/rag/ask`;
export const RAG_HISTORY = `${HOST}/api/rag/history`;


export const GAME_PLAY_BY_PLAY = `${HOST}/api/gameplay`;
